import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import CloseIcon from '-!svg-react-loader!./assets/close.svg?name=CloseIcon';

import './badgeStyles.scss';

class Badge extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { label, active, onClick, showIcon, disabled } = this.props;
    return (
      <div
        className={classnames({
          'chip': true,
          'active': active,
          'disabled': disabled,
        })}
        onClick={disabled ? null : onClick}
      >
        <span>
          {active && (
            <>
              {label} {showIcon && <CloseIcon />}
            </>
          )}
          {!active && label}
        </span>
      </div>
    );
  }
}

Badge.defaultProps = {
  active: false,
  showIcon: true,
  onClick: null,
  disabled: false,
};
Badge.propTypes = {
  label: PropTypes.string.isRequired,
  active: PropTypes.bool,
  showIcon: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
export default Badge;
